import React from 'react';
import { Container, Box, Typography, Card, CardContent, CardMedia, Grid } from '@mui/material';
import { Link } from 'react-router-dom';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { withAuth } from '../../../components/HOC/withAuth';
import useResponsive from '../../../hooks/useResponsive';

function Main() {
  const isMobileOrTablet = useResponsive('down', 'md');

  const cardData = [
    {
      title: 'Search External Data',
      description: 'Access a wealth of knowledge in medical affairs by simply asking your questions.',
      image: 'https://acma-media-bucket.s3.us-east-2.amazonaws.com/images/brand/ai/external-v3.svg',
      link: '/external',
    },
    {
      title: 'Search Internal Data',
      description: 'Effortlessly retrieve answers by querying your internally uploaded documents.',
      image: 'https://acma-media-bucket.s3.us-east-2.amazonaws.com/images/brand/ai/internal-v3.svg',
      link: '/internal',
    },
  ];

  return (
    <Container maxWidth="lg" sx={{ py: { xs: 4, md: 6 } }}>
      {/* Header */}
      <Box sx={{ textAlign: 'center', mb: { xs: 4, md: 6 }, mt: { xs: 2, md: 4 } }}>
        <Typography
          variant="h3"
          component="h1"
          sx={{
            fontWeight: 'bold',
            color: '#1f2937',
            mb: 2,
            fontSize: { xs: '2rem', sm: '2.5rem', md: '3rem' },
          }}
        >
          Welcome to MedAffairs AI
        </Typography>
        <Typography
          variant="h6"
          sx={{
            color: '#6b7280',
            fontWeight: 400,
          }}
        >
          Real-time Medical Affairs Insights When You Need It
        </Typography>
      </Box>

      {/* Cards */}
      <Grid container spacing={4}>
        {cardData.map((card, index) => (
          <Grid item xs={12} md={6} key={index}>
            <Card
              component={Link}
              to={card.link}
              sx={{
                height: '100%',
                textDecoration: 'none',
                borderRadius: 2,
                overflow: 'hidden',
                transition: 'all 0.3s ease',
                boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                '&:hover': {
                  transform: 'translateY(-4px)',
                  boxShadow: '0 8px 25px rgba(0,0,0,0.15)',
                  '& .card-image': {
                    transform: 'scale(1.05)',
                  },
                },
              }}
            >
              <CardMedia
                component="img"
                height="120"
                image={card.image}
                alt={card.title}
                className="card-image"
                sx={{
                  transition: 'transform 0.3s ease',
                  objectFit: 'cover',
                }}
              />
              <CardContent sx={{ p: 3 }}>
                <Typography
                  variant="h5"
                  component="h3"
                  sx={{
                    fontWeight: 'bold',
                    color: '#1f2937',
                    mb: 2,
                  }}
                >
                  {card.title}
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    color: '#6b7280',
                    mb: 3,
                    lineHeight: 1.6,
                  }}
                >
                  {card.description}
                </Typography>
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    color: '#2563eb',
                    fontWeight: 600,
                  }}
                >
                  Get started
                  <ArrowForwardIcon sx={{ ml: 1, fontSize: 20 }} />
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
}

export default withAuth(Main);
